// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
// convexClient — the single ConvexReactClient instance for the experiment (#191).
//
// Created lazily and only when a CONVEX_URL is configured. When the experiment
// is off (default), this module exports `null` and nothing connects — the
// websocket is never opened, so the production path is wholly unaffected.
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

import { ConvexReactClient } from "convex/react";
import { CONVEX_URL } from "../utility/backendConfig";

let client = null;
if (CONVEX_URL) {
  client = new ConvexReactClient(CONVEX_URL);
}

export const convexClient = client;
